import { render, staticRenderFns } from "./ListStudents.vue?vue&type=template&id=2c142844&"
import script from "./ListStudents.vue?vue&type=script&lang=ts&"
export * from "./ListStudents.vue?vue&type=script&lang=ts&"
import style0 from "./ListStudents.vue?vue&type=style&index=0&id=2c142844&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports